import { getCurrentScriptBasePath } from './utils';

const basePath = getCurrentScriptBasePath();

if (!basePath) {
  throw new Error("Unable to determine currentScript basePath, webpack's publicPath is not specified");
}

// @ts-ignore
__webpack_public_path__ = basePath;
